import { render, staticRenderFns } from "./form5_3.vue?vue&type=template&id=d0ca3e5e&scoped=true"
import script from "./form5_3.vue?vue&type=script&lang=js"
export * from "./form5_3.vue?vue&type=script&lang=js"
import style0 from "./form5_3.vue?vue&type=style&index=0&id=d0ca3e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ca3e5e",
  null
  
)

export default component.exports